import React, { memo } from 'react';
import AgentBadge from './AgentBadge';

const CATEGORY_ICONS = {
  DEPLOY: '',
  INSTALL: '',
  BUILD: '',
  RUNTIME: '',
};

function LogEntry({ log }) {
  const categoryIcon = CATEGORY_ICONS[log.agentType];
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        padding: '6px 10px',
        borderRadius: 8,
        background: log.type === 'error' ? 'rgba(239,68,68,0.06)' : 'var(--bg-card)',
        borderLeft: log.type === 'error' ? '2px solid #ef4444' : log.type === 'success' ? '2px solid #22c55e' : '2px solid transparent',
      }}
    >
      <span style={{ fontSize: 10, color: 'var(--text-muted)', flexShrink: 0, marginTop: 1 }}>{log.time}</span>
      {categoryIcon && <span style={{ fontSize: 12, flexShrink: 0 }}>{categoryIcon}</span>}
      <AgentBadge agent={log.agentType} />
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: 'var(--text-secondary)',
            fontFamily: "'JetBrains Mono', monospace",
            wordBreak: 'break-word',
          }}
        >
          {log.event}
        </div>
        {log.detail ? (
          <div
            style={{
              fontSize: 11,
              color: 'var(--text-muted)',
              fontFamily: "'JetBrains Mono', monospace",
              wordBreak: 'break-word',
              lineHeight: 1.5,
              whiteSpace: 'pre-wrap',
            }}
          >
            {log.detail}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default memo(LogEntry);

